import React from "react"
export default function ErrorMessage({ errors, handleHideMsg}) {
    return (
        <>
          {errors.length>0 && 
            <div className="flex flex-row justify-between px-4 py-4 h-auto bg-red-50 text-left sm:px-6 shadow-sm">
              {/* <div className="list-none text-md text-red-500">     
                <span>{errors}</span>
              </div>
              <div className="list-none text-md text-red-500">     
                <button onClick={handleHideMsg} >x</button>
              </div> */}
               <div className="list-none text-sm text-red-500">
                <ul className="list-disc list-inside text-xs text-red-600">
                  {errors.map(error => (
                      <li key={error}>{error}</li>
                  ))}
                </ul>    
              </div>
            </div>
          }
        </>
    )
}

export function ErrorMessageAuth({ errors }) {
    return (
        <>
          <div className="list-none text-sm text-red-500">
            <span className="list-disc list-inside text-base text-red-600">
              {errors}
            </span>    
          </div>
        </>
    )
}
